import React, { useState, useEffect } from 'react';
import { imageCache } from '../../utils/imageCache';

interface CachedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    placeholder?: string;
}

const CachedImage: React.FC<CachedImageProps> = ({ src, placeholder, alt, className, style, ...props }) => {
    const [displaySrc, setDisplaySrc] = useState<string>(placeholder || src);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const loadImage = async () => {
            if (!src) return;
            
            try {
                // Try to get from persistent cache
                const cachedUrl = await imageCache.getCachedImageUrl(src);
                if (isMounted) {
                    setDisplaySrc(cachedUrl);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Failed to load cached image:', error);
                if (isMounted) {
                    setDisplaySrc(src);
                    setIsLoading(false);
                }
            }
        };

        loadImage();

        return () => {
            isMounted = false;
        };
    }, [src]);

    return (
        <img
            src={displaySrc}
            alt={alt}
            className={`${className} ${isLoading ? 'blur-sm transition-all duration-300' : 'blur-0 transition-all duration-500'}`}
            style={style}
            {...props}
        />
    );
};

export default CachedImage;
